import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { VesselRedundancyWcfdi } from '../dto/vessel-redundancy-wcfdi';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VesselRedundancyWcfdiService {

  private apiUrl = environment.apiRoot + '/vesselredundancywcfdi';

  constructor(private http: HttpClient) { }

  getAllRedundancyWCFDIOfVessel(vesselId: number): Observable<VesselRedundancyWcfdi[]> {
    return this.http.get<VesselRedundancyWcfdi[]>(this.apiUrl + '/allofvessel?vesselId=' + vesselId);
  }

  createRedundancyWCFDI(vesselId: number): Observable<VesselRedundancyWcfdi> {
    let model = { "id": 0, "vessel_id": vesselId, "name": "new WCFDI" };
    return this.http.post<VesselRedundancyWcfdi>(this.apiUrl + '/new', model);
  }

  updateRedundancyWCFDI(model: VesselRedundancyWcfdi): Observable<VesselRedundancyWcfdi> {
    return this.http.put<VesselRedundancyWcfdi>(this.apiUrl + '/update', model);
  }

  deleteRedundancyWCFDI(wcfdiId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?wcfdiId=' + wcfdiId);
  }
}
